const config = {
    apiUrl: 'https://agilerobots.com.br/api' 
  };
  export default config;
